import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

    //console.log("======================================");
    //console.log(window.location.protocol);
    //console.log(window.location.hostname);
    //console.log("======================================");

    // Expose globally so all components can use
    //window.API_BASE_URL = window.location.protocol + "//" + window.location.hostname;

    //window.API_BASE_URL = window.location.protocol + "//" + window.location.hostname + ":" + window.location.port + "";
    ////window.UNITY_WEBGL_URL = window.location.protocol + "//" + window.location.hostname + ":8000";
    //window.UNITY_WEBGL_URL = window.location.protocol + "//" + window.location.hostname + ":" + window.location.port + "/unity/";

    //// Detect environment from the URL path
	//const path = window.location.pathname.toLowerCase();
	//const isDemo = path.startsWith("/demo");
//
	//// Construct API base URLs accordingly
	//if (isDemo) {
	//  // Demo environment
	//  window.API_BASE_URL = window.location.protocol + "//" + window.location.hostname + ":" + window.location.port + "/demo";
	//} else {
	//  // Production environment
	//  window.API_BASE_URL = window.location.protocol + "//" + window.location.hostname + ":" + window.location.port + "";
	//}

	//// Unity WebGL URL (same for both, but if you have separate builds, adjust similarly)
	//window.UNITY_WEBGL_URL = window.location.protocol + "//" + window.location.hostname + ":" + window.location.port + "/unity/";

	const currentPath = window.location.pathname;

	// Detect demo or prod
	if (currentPath.startsWith("/demo") || currentPath.startsWith("/endomyoma")) {
	  // Demo environment
	  window.API_BASE_URL = window.location.origin + "/demo/api/";
	} else {
	  // Production environment
	  window.API_BASE_URL = window.location.origin + "/api/";
	}
	
	// Unity path can remain same
    window.UNITY_WEBGL_URL = window.location.origin + "/unity/";


    //console.log("######################################");
    //console.log(window.location.pathname);
	//console.log(window.API_BASE_URL);
	//console.log(window.UNITY_WEBGL_URL);
    //console.log("######################################");

    // Step 2: Render app after config is loaded
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(
      //<React.StrictMode>
        <App />
      //</React.StrictMode>
    );

    reportWebVitals();

//// Step 1: Fetch config.json from backend before rendering
//fetch('/api/config')
//  .then((res) => res.json())
//  .then((config) => {
//    // Expose globally so all components can use
//    window.API_BASE_URL = config.API_BASE_URL;
//    window.UNITY_WEBGL_URL = config.UNITY_WEBGL_URL;
//
//    console.log("######################################");
//	console.log(window.API_BASE_URL);
//    console.log(window.UNITY_WEBGL_URL);
//    console.log("######################################");
//
//    // Step 2: Render app after config is loaded
//    const root = ReactDOM.createRoot(document.getElementById('root'));
//    root.render(
//      //<React.StrictMode>
//        <App />
//      //</React.StrictMode>
//    );
//
//    reportWebVitals();
//  })
//  .catch((err) => {
//    console.error("Failed to load config.json", err);
//  });
